// @flow
import { getCreator } from '../../http';
import environment from '../../environment';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

export const endpoints = Object.freeze({
  SCRAP_URL: `${environment.apiUrl}/scrapper`,
});

export const scrapUrlApi = getCreator(fetch, endpoints.SCRAP_URL);
/*export const scrapUrlApi = () => of(
  {
    "categoryId": null,
    "country": "US",
    "detailOptions": {
      "preselected": null,
      "variationDimensions": {
        "Color": [
          "Black Berber",
          "Black",
          "Black Tweed",
          "Blue Check",
          "Brown Berber",
          "Brown Tweed",
          "Charcoal",
          "Dark Charcoal",
          "Earth Tex",
          "Navy Tweed",
          "Urban Camo",
          "Stonewash Black Canvas",
          "Chutney Plaid",
          "Toast Canvas",
        ],
        "Size": [
          "7.5-8.5",
          "7.5-8.5 Wide",
          "9-10",
          "9-10 Wide",
          "10.5-11.5",
          "10.5-11.5 Wide",
          "12-13",
          "12-13 Wide",
          "14-15",
          "15-16",
        ],
      },
      "variationRouting": {
        "Color": {
          "Black": {
            "Size": {
              "10.5-11.5": "B00I3MW0L4",
              "12-13": "B00I3MWD98",
              "14-15": "B00I3MWGZ4",
              "7.5-8.5": "B00I3MWACI",
              "9-10": "B00I3MW6GI",
            },
          },
          "Black Berber": {
            "Size": {
              "10.5-11.5": "B00I3MUTBW",
              "10.5-11.5 Wide": "B01LXVDUGG",
              "12-13": "B00I3MV03S",
              "12-13 Wide": "B01LWKGOF8",
              "14-15": "B00I3MV1SM",
              "15-16": "B00L3ZRMF2",
              "7.5-8.5": "B00I3MUXX6",
              "7.5-8.5 Wide": "B01M14I2VT",
              "9-10": "B00I3MUW0K",
              "9-10 Wide": "B01LY71Q09",
            },
          },
          "Black Tweed": {
            "Size": {
              "10.5-11.5": "B07DFZGF3D",
              "12-13": "B07DFV3SCM",
              "14-15": "B07DFZB9YW",
              "7.5-8.5": "B07DFYCHDR",
              "9-10": "B07DFXT1B9",
            },
          },
          "Blue Check": {
            "Size": {
              "10.5-11.5": "B00I3MV67S",
              "12-13": "B00I3MVHTK",
              "14-15": "B00I3MVKWE",
              "7.5-8.5": "B00I3MVDIK",
              "9-10": "B00I3MV85I",
            },
          },
          "Brown Berber": {
            "Size": {
              "10.5-11.5": "B07NP33YMB",
              "12-13": "B07NNY8FTG",
              "14-15": "B07NNVGMVY",
              "7.5-8.5": "B07NNPBH65",
              "9-10": "B07NNMYM98",
            },
          },
          "Brown Tweed": {
            "Size": {
              "10.5-11.5": "B07DG3HJLW",
              "12-13": "B07DFV8MCJ",
              "14-15": "B07DFZR5C6",
              "7.5-8.5": "B07DG327YH",
              "9-10": "B07DFZRG3Z",
            },
          },
          "Charcoal": {
            "Size": {
              "10.5-11.5": "B00I3MYCW4",
              "12-13": "B00I3MYOC2",
              "14-15": "B00I3MYRWO",
              "7.5-8.5": "B00I3MYLIY",
              "9-10": "B00I3MYIZU",
            },
          },
          "Chutney Plaid": {
            "Size": {
              "10.5-11.5": "B00I3MYXU0",
              "12-13": "B00I3MZ7L4",
              "9-10": "B00I3MZ0IE",
            },
          },
          "Dark Charcoal": {
            "Size": {
              "10.5-11.5": "B01N4MSC51",
              "12-13": "B01NBTG01V",
              "14-15": "B01MT7TTA0",
              "7.5-8.5": "B01MY705B6",
              "9-10": "B01N4MSCFY",
            },
          },
          "Earth Tex": {
            "Size": {
              "10.5-11.5": "B00I3MX99G",
              "12-13": "B00I3MXMFC",
              "14-15": "B0742MTFJ6",
              "7.5-8.5": "B00I3MXJGO",
              "9-10": "B00I3MXHBG",
            },
          },
          "Navy Tweed": {
            "Size": {
              "10.5-11.5": "B079GBF4D9",
              "12-13": "B079K4MCG4",
              "14-15": "B079RM32S4",
              "7.5-8.5": "B079RKLNJD",
              "9-10": "B079941SL3",
            },
          },
          "Stonewash Black Canvas": {
            "Size": {
              "10.5-11.5": "B0134RCQ2A",
              "12-13": "B0134RCU2G",
              "7.5-8.5": "B0134RCGO8",
              "9-10": "B0134RCL52",
            },
          },
          "Toast Canvas": {
            "Size": {
              "10.5-11.5": "B0134RC8RS",
            },
          },
          "Urban Camo": {
            "Size": {
              "10.5-11.5": "B079RL63HY",
              "12-13": "B079RL7HDT",
              "14-15": "B07DFX4Q2T",
              "7.5-8.5": "B079RM3X1B",
              "9-10": "B079NTV4ZC",
            },
          },
        },
        "Size": {
          "10.5-11.5": {
            "Color": {
              "Black": "B00I3MW0L4",
              "Black Berber": "B00I3MUTBW",
              "Black Tweed": "B07DFZGF3D",
              "Blue Check": "B00I3MV67S",
              "Brown Berber": "B07NP33YMB",
              "Brown Tweed": "B07DG3HJLW",
              "Charcoal": "B00I3MYCW4",
              "Chutney Plaid": "B00I3MYXU0",
              "Dark Charcoal": "B01N4MSC51",
              "Earth Tex": "B00I3MX99G",
              "Navy Tweed": "B079GBF4D9",
              "Stonewash Black Canvas": "B0134RCQ2A",
              "Toast Canvas": "B0134RC8RS",
              "Urban Camo": "B079RL63HY",
            },
          },
          "10.5-11.5 Wide": {
            "Color": {
              "Black Berber": "B01LXVDUGG",
            },
          },
          "12-13": {
            "Color": {
              "Black": "B00I3MWD98",
              "Black Berber": "B00I3MV03S",
              "Black Tweed": "B07DFV3SCM",
              "Blue Check": "B00I3MVHTK",
              "Brown Berber": "B07NNY8FTG",
              "Brown Tweed": "B07DFV8MCJ",
              "Charcoal": "B00I3MYOC2",
              "Chutney Plaid": "B00I3MZ7L4",
              "Dark Charcoal": "B01NBTG01V",
              "Earth Tex": "B00I3MXMFC",
              "Navy Tweed": "B079K4MCG4",
              "Stonewash Black Canvas": "B0134RCU2G",
              "Urban Camo": "B079RL7HDT",
            },
          },
          "12-13 Wide": {
            "Color": {
              "Black Berber": "B01LWKGOF8",
            },
          },
          "14-15": {
            "Color": {
              "Black": "B00I3MWGZ4",
              "Black Berber": "B00I3MV1SM",
              "Black Tweed": "B07DFZB9YW",
              "Blue Check": "B00I3MVKWE",
              "Brown Berber": "B07NNVGMVY",
              "Brown Tweed": "B07DFZR5C6",
              "Charcoal": "B00I3MYRWO",
              "Dark Charcoal": "B01MT7TTA0",
              "Earth Tex": "B0742MTFJ6",
              "Navy Tweed": "B079RM32S4",
              "Urban Camo": "B07DFX4Q2T",
            },
          },
          "15-16": {
            "Color": {
              "Black Berber": "B00L3ZRMF2",
            },
          },
          "7.5-8.5": {
            "Color": {
              "Black": "B00I3MWACI",
              "Black Berber": "B00I3MUXX6",
              "Black Tweed": "B07DFYCHDR",
              "Blue Check": "B00I3MVDIK",
              "Brown Berber": "B07NNPBH65",
              "Brown Tweed": "B07DG327YH",
              "Charcoal": "B00I3MYLIY",
              "Dark Charcoal": "B01MY705B6",
              "Earth Tex": "B00I3MXJGO",
              "Navy Tweed": "B079RKLNJD",
              "Stonewash Black Canvas": "B0134RCGO8",
              "Urban Camo": "B079RM3X1B",
            },
          },
          "7.5-8.5 Wide": {
            "Color": {
              "Black Berber": "B01M14I2VT",
            },
          },
          "9-10": {
            "Color": {
              "Black": "B00I3MW6GI",
              "Black Berber": "B00I3MUW0K",
              "Black Tweed": "B07DFXT1B9",
              "Blue Check": "B00I3MV85I",
              "Brown Berber": "B07NNMYM98",
              "Brown Tweed": "B07DFZRG3Z",
              "Charcoal": "B00I3MYIZU",
              "Chutney Plaid": "B00I3MZ0IE",
              "Dark Charcoal": "B01N4MSCFY",
              "Earth Tex": "B00I3MXHBG",
              "Navy Tweed": "B079941SL3",
              "Stonewash Black Canvas": "B0134RCL52",
              "Urban Camo": "B079NTV4ZC",
            },
          },
          "9-10 Wide": {
            "Color": {
              "Black Berber": "B01LY71Q09",
            },
          },
        },
      },
      "variations": {
        "B00I3MUTBW": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Berber, 10.5-11.5",
          "price": "33.21",
          "url": "https://www.amazon.com/dp/B00I3MUTBW?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": "26.97",
          },
          "weight": "0.16",
        },
        "B00I3MUW0K": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Berber, 9-10",
          "price": "45.0",
          "url": "https://www.amazon.com/dp/B00I3MUW0K?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": "0.16",
        },
        "B00I3MUXX6": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Berber, 7.5-8.5",
          "price": "26.97",
          "url": "https://www.amazon.com/dp/B00I3MUXX6?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM CLASSIC MOCCASIN SLIPPER:  Men\u2019s signature comfort slipper in slip-on closed back design with indoor & outdoor support.",
              "SOFT AND COZY UPPERS: Soft fleece, faux fur, or berber uppers deliver timeless style and warmth, while moisture-wicking berber lining keeps feet comfortable and dry.",
              "MEMORY FOAM CUSHIONING: Resilient multilayer memory foam adds support and cushion after a long day of walking or standing.",
              "GENUINE SUEDE & DURABLE SOLE: Real suede sidewall and durable rubber outsole provide weatherproof, skid-resistant traction for indoor or outdoor wear.",
              "VERSATILE & EASY CARE: This all-day slipper transitions from house to travel to bedroom and is perfect for men of all ages and lifestyles. Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
            ],
            "lowest_price": "26.97",
          },
          "weight": "0.16",
        },
        "B00I3MV03S": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Berber, 12-13",
          "price": "44.93",
          "url": "https://www.amazon.com/dp/B00I3MV03S?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": "44.93",
          },
          "weight": "0.16",
        },
        "B00I3MV1SM": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Black Berber, 13.5-14.5",
          "price": "40.67",
          "url": "https://www.amazon.com/dp/B00I3MV1SM?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "40.67",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": "39.0",
          },
          "weight": "0.16",
        },
        "B00I3MV67S": {
          "image": "https://m.media-amazon.com/images/I/41udmtCRlnL.jpg",
          "name": "Acorn Men's Moc Slippers, Blue Check, 10.5-11.5",
          "price": "39.99",
          "url": "https://www.amazon.com/dp/B00I3MV67S?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM CLASSIC MOCCASIN SLIPPER:  Men\u2019s signature comfort slipper in slip-on closed back design with indoor & outdoor support.",
              "SOFT AND COZY UPPERS: Soft fleece, faux fur, or berber uppers deliver timeless style and warmth, while moisture-wicking berber lining keeps feet comfortable and dry.",
              "MEMORY FOAM CUSHIONING: Resilient multilayer memory foam adds support and cushion after a long day of walking or standing.",
              "GENUINE SUEDE & DURABLE SOLE: Real suede sidewall and durable rubber outsole provide weatherproof, skid-resistant traction for indoor or outdoor wear.",
              "VERSATILE & EASY CARE: This all-day slipper transitions from house to travel to bedroom and is perfect for men of all ages and lifestyles. Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mkz-OT2qL.jpg",
              "https://m.media-amazon.com/images/I/51xscTdvkPL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51Vac1mi7IL.jpg",
              "https://m.media-amazon.com/images/I/41XfKut8-UL.jpg",
              "https://m.media-amazon.com/images/I/41i8RGbvWlL.jpg",
              "https://m.media-amazon.com/images/I/41tMBRDu+sL.jpg",
              "https://m.media-amazon.com/images/I/41cytSWd7AL.jpg",
              "https://m.media-amazon.com/images/I/41foCn2hD9L.jpg",
            ],
            "lowest_price": "39.99",
          },
          "weight": "0.16",
        },
        "B00I3MV85I": {
          "image": "https://m.media-amazon.com/images/I/41udmtCRlnL.jpg",
          "name": "Acorn Men's Moc Slippers, Blue Check, 9-10",
          "price": "39.99",
          "url": "https://www.amazon.com/dp/B00I3MV85I?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM CLASSIC MOCCASIN SLIPPER:  Men\u2019s signature comfort slipper in slip-on closed back design with indoor & outdoor support.",
              "SOFT AND COZY UPPERS: Soft fleece, faux fur, or berber uppers deliver timeless style and warmth, while moisture-wicking berber lining keeps feet comfortable and dry.",
              "MEMORY FOAM CUSHIONING: Resilient multilayer memory foam adds support and cushion after a long day of walking or standing.",
              "GENUINE SUEDE & DURABLE SOLE: Real suede sidewall and durable rubber outsole provide weatherproof, skid-resistant traction for indoor or outdoor wear.",
              "VERSATILE & EASY CARE: This all-day slipper transitions from house to travel to bedroom and is perfect for men of all ages and lifestyles. Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41tMBRDu+sL.jpg",
              "https://m.media-amazon.com/images/I/51mkz-OT2qL.jpg",
              "https://m.media-amazon.com/images/I/51xscTdvkPL.jpg",
              "https://m.media-amazon.com/images/I/51Vac1mi7IL.jpg",
              "https://m.media-amazon.com/images/I/41XfKut8-UL.jpg",
              "https://m.media-amazon.com/images/I/41i8RGbvWlL.jpg",
              "https://m.media-amazon.com/images/I/41cytSWd7AL.jpg",
              "https://m.media-amazon.com/images/I/41foCn2hD9L.jpg",
            ],
            "lowest_price": "39.99",
          },
          "weight": "0.16",
        },
        "B00I3MVDIK": {
          "image": "https://m.media-amazon.com/images/I/41udmtCRlnL.jpg",
          "name": "Acorn Men's Moc Slippers, Blue Check, 7.5-8.5",
          "price": "33.73",
          "url": "https://www.amazon.com/dp/B00I3MVDIK?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM CLASSIC MOCCASIN SLIPPER:  Men\u2019s signature comfort slipper in slip-on closed back design with indoor & outdoor support.",
              "SOFT AND COZY UPPERS: Soft fleece, faux fur, or berber uppers deliver timeless style and warmth, while moisture-wicking berber lining keeps feet comfortable and dry.",
              "MEMORY FOAM CUSHIONING: Resilient multilayer memory foam adds support and cushion after a long day of walking or standing.",
              "GENUINE SUEDE & DURABLE SOLE: Real suede sidewall and durable rubber outsole provide weatherproof, skid-resistant traction for indoor or outdoor wear.",
              "VERSATILE & EASY CARE: This all-day slipper transitions from house to travel to bedroom and is perfect for men of all ages and lifestyles. Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51mkz-OT2qL.jpg",
              "https://m.media-amazon.com/images/I/51xscTdvkPL.jpg",
              "https://m.media-amazon.com/images/I/51Vac1mi7IL.jpg",
              "https://m.media-amazon.com/images/I/41XfKut8-UL.jpg",
              "https://m.media-amazon.com/images/I/41i8RGbvWlL.jpg",
              "https://m.media-amazon.com/images/I/41tMBRDu+sL.jpg",
              "https://m.media-amazon.com/images/I/41cytSWd7AL.jpg",
              "https://m.media-amazon.com/images/I/41foCn2hD9L.jpg",
            ],
            "lowest_price": "33.73",
          },
          "weight": "0.16",
        },
        "B00I3MVHTK": {
          "image": "https://m.media-amazon.com/images/I/41udmtCRlnL.jpg",
          "name": "Acorn Men's Moc Slippers, Blue Check, 12-13",
          "price": "37.33",
          "url": "https://www.amazon.com/dp/B00I3MVHTK?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM CLASSIC MOCCASIN SLIPPER:  Men\u2019s signature comfort slipper in slip-on closed back design with indoor & outdoor support.",
              "SOFT AND COZY UPPERS: Soft fleece, faux fur, or berber uppers deliver timeless style and warmth, while moisture-wicking berber lining keeps feet comfortable and dry.",
              "MEMORY FOAM CUSHIONING: Resilient multilayer memory foam adds support and cushion after a long day of walking or standing.",
              "GENUINE SUEDE & DURABLE SOLE: Real suede sidewall and durable rubber outsole provide weatherproof, skid-resistant traction for indoor or outdoor wear.",
              "VERSATILE & EASY CARE: This all-day slipper transitions from house to travel to bedroom and is perfect for men of all ages and lifestyles. Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51mkz-OT2qL.jpg",
              "https://m.media-amazon.com/images/I/51xscTdvkPL.jpg",
              "https://m.media-amazon.com/images/I/51Vac1mi7IL.jpg",
              "https://m.media-amazon.com/images/I/41XfKut8-UL.jpg",
              "https://m.media-amazon.com/images/I/41i8RGbvWlL.jpg",
              "https://m.media-amazon.com/images/I/41tMBRDu+sL.jpg",
              "https://m.media-amazon.com/images/I/41cytSWd7AL.jpg",
              "https://m.media-amazon.com/images/I/41foCn2hD9L.jpg",
            ],
            "lowest_price": "35.96",
          },
          "weight": "0.16",
        },
        "B00I3MVKWE": {
          "image": "https://m.media-amazon.com/images/I/41udmtCRlnL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Blue Check, 13.5-14.5",
          "price": "39.99",
          "url": "https://www.amazon.com/dp/B00I3MVKWE?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51mkz-OT2qL.jpg",
              "https://m.media-amazon.com/images/I/51xscTdvkPL.jpg",
              "https://m.media-amazon.com/images/I/51Vac1mi7IL.jpg",
              "https://m.media-amazon.com/images/I/41XfKut8-UL.jpg",
              "https://m.media-amazon.com/images/I/41i8RGbvWlL.jpg",
              "https://m.media-amazon.com/images/I/41tMBRDu+sL.jpg",
              "https://m.media-amazon.com/images/I/41cytSWd7AL.jpg",
              "https://m.media-amazon.com/images/I/41foCn2hD9L.jpg",
            ],
            "lowest_price": "39.0",
          },
          "weight": "0.16",
        },
        "B00I3MW0L4": {
          "image": "https://m.media-amazon.com/images/I/41Ht1dqhmHL.jpg",
          "name": "Acorn Men's Moc Slippers, Black, 10.5-11.5",
          "price": "30.59",
          "url": "https://www.amazon.com/dp/B00I3MW0L4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41PQ4of2TlL.jpg",
              "https://m.media-amazon.com/images/I/51pz1QonTkL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4192YwyeXML.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/41-mfnvdDpL.jpg",
              "https://m.media-amazon.com/images/I/315Dg3EqYfL.jpg",
              "https://m.media-amazon.com/images/I/41-ajI50LbL.jpg",
              "https://m.media-amazon.com/images/I/31RXdssHw9L.jpg",
              "https://m.media-amazon.com/images/I/31rr4-9A8BL.jpg",
            ],
            "lowest_price": "30.59",
          },
          "weight": "0.16",
        },
        "B00I3MW6GI": {
          "image": "https://m.media-amazon.com/images/I/41Ht1dqhmHL.jpg",
          "name": "Acorn Men's Moc Slippers, Black, 9-10",
          "price": "30.59",
          "url": "https://www.amazon.com/dp/B00I3MW6GI?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/4192YwyeXML.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41-mfnvdDpL.jpg",
              "https://m.media-amazon.com/images/I/41-ajI50LbL.jpg",
              "https://m.media-amazon.com/images/I/31rr4-9A8BL.jpg",
              "https://m.media-amazon.com/images/I/41PQ4of2TlL.jpg",
              "https://m.media-amazon.com/images/I/51pz1QonTkL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/315Dg3EqYfL.jpg",
              "https://m.media-amazon.com/images/I/31RXdssHw9L.jpg",
            ],
            "lowest_price": "30.59",
          },
          "weight": "0.16",
        },
        "B00I3MWACI": {
          "image": "https://m.media-amazon.com/images/I/41Ht1dqhmHL.jpg",
          "name": "Acorn Men's Moc Slippers, Black, 7.5-8.5",
          "price": "30.59",
          "url": "https://www.amazon.com/dp/B00I3MWACI?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/315Dg3EqYfL.jpg",
              "https://m.media-amazon.com/images/I/31RXdssHw9L.jpg",
              "https://m.media-amazon.com/images/I/41PQ4of2TlL.jpg",
              "https://m.media-amazon.com/images/I/51pz1QonTkL.jpg",
              "https://m.media-amazon.com/images/I/4192YwyeXML.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/41-mfnvdDpL.jpg",
              "https://m.media-amazon.com/images/I/41-ajI50LbL.jpg",
              "https://m.media-amazon.com/images/I/31rr4-9A8BL.jpg",
            ],
            "lowest_price": "30.59",
          },
          "weight": "0.16",
        },
        "B00I3MWD98": {
          "image": "https://m.media-amazon.com/images/I/41Ht1dqhmHL.jpg",
          "name": "Acorn Men's Moc Slippers, Black, 12-13",
          "price": "30.59",
          "url": "https://www.amazon.com/dp/B00I3MWD98?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41PQ4of2TlL.jpg",
              "https://m.media-amazon.com/images/I/51pz1QonTkL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4192YwyeXML.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/41-mfnvdDpL.jpg",
              "https://m.media-amazon.com/images/I/315Dg3EqYfL.jpg",
              "https://m.media-amazon.com/images/I/41-ajI50LbL.jpg",
              "https://m.media-amazon.com/images/I/31RXdssHw9L.jpg",
              "https://m.media-amazon.com/images/I/31rr4-9A8BL.jpg",
            ],
            "lowest_price": "30.59",
          },
          "weight": "0.16",
        },
        "B00I3MWGZ4": {
          "image": "https://m.media-amazon.com/images/I/41Ht1dqhmHL.jpg",
          "name": "Acorn Men's Moc Slippers, Black, 14-15",
          "price": "42.75",
          "url": "https://www.amazon.com/dp/B00I3MWGZ4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "42.75",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41PQ4of2TlL.jpg",
              "https://m.media-amazon.com/images/I/51pz1QonTkL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4192YwyeXML.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/41-mfnvdDpL.jpg",
              "https://m.media-amazon.com/images/I/315Dg3EqYfL.jpg",
              "https://m.media-amazon.com/images/I/41-ajI50LbL.jpg",
              "https://m.media-amazon.com/images/I/31RXdssHw9L.jpg",
              "https://m.media-amazon.com/images/I/31rr4-9A8BL.jpg",
            ],
            "lowest_price": "42.75",
          },
          "weight": "0.16",
        },
        "B00I3MX99G": {
          "image": "https://m.media-amazon.com/images/I/41GHNV7u6wL.jpg",
          "name": "Acorn Men's Moc Slippers, Earth Tex, 10.5-11.5",
          "price": "33.71",
          "url": "https://www.amazon.com/dp/B00I3MX99G?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "50.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51YSFQpfiqL.jpg",
              "https://m.media-amazon.com/images/I/51EYyXzQBrL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31nPQSeumxL.jpg",
              "https://m.media-amazon.com/images/I/41ymHW1F8GL.jpg",
              "https://m.media-amazon.com/images/I/41M2zbGYvGL.jpg",
              "https://m.media-amazon.com/images/I/41+r0+pbcKL.jpg",
              "https://m.media-amazon.com/images/I/41SgLGYD4uL.jpg",
            ],
            "lowest_price": "33.71",
          },
          "weight": "0.16",
        },
        "B00I3MXHBG": {
          "image": "https://m.media-amazon.com/images/I/41GHNV7u6wL.jpg",
          "name": "Acorn Men's Moc Slippers, Earth Tex, 9-10",
          "price": "33.71",
          "url": "https://www.amazon.com/dp/B00I3MXHBG?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51YSFQpfiqL.jpg",
              "https://m.media-amazon.com/images/I/51EYyXzQBrL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31nPQSeumxL.jpg",
              "https://m.media-amazon.com/images/I/41ymHW1F8GL.jpg",
              "https://m.media-amazon.com/images/I/41M2zbGYvGL.jpg",
              "https://m.media-amazon.com/images/I/41+r0+pbcKL.jpg",
              "https://m.media-amazon.com/images/I/41SgLGYD4uL.jpg",
            ],
            "lowest_price": "33.71",
          },
          "weight": "0.16",
        },
        "B00I3MXJGO": {
          "image": "https://m.media-amazon.com/images/I/41GHNV7u6wL.jpg",
          "name": "Acorn Men's Moc Slippers, Earth Tex, 7.5-8.5",
          "price": "33.72",
          "url": "https://www.amazon.com/dp/B00I3MXJGO?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51YSFQpfiqL.jpg",
              "https://m.media-amazon.com/images/I/51EYyXzQBrL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31nPQSeumxL.jpg",
              "https://m.media-amazon.com/images/I/41ymHW1F8GL.jpg",
              "https://m.media-amazon.com/images/I/41M2zbGYvGL.jpg",
              "https://m.media-amazon.com/images/I/41+r0+pbcKL.jpg",
              "https://m.media-amazon.com/images/I/41SgLGYD4uL.jpg",
            ],
            "lowest_price": "33.72",
          },
          "weight": "0.16",
        },
        "B00I3MXMFC": {
          "image": "https://m.media-amazon.com/images/I/41GHNV7u6wL.jpg",
          "name": "Acorn Men's Moc Slippers, Earth Tex, 12-13",
          "price": "35.52",
          "url": "https://www.amazon.com/dp/B00I3MXMFC?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51YSFQpfiqL.jpg",
              "https://m.media-amazon.com/images/I/51EYyXzQBrL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31nPQSeumxL.jpg",
              "https://m.media-amazon.com/images/I/41ymHW1F8GL.jpg",
              "https://m.media-amazon.com/images/I/41M2zbGYvGL.jpg",
              "https://m.media-amazon.com/images/I/41+r0+pbcKL.jpg",
              "https://m.media-amazon.com/images/I/41SgLGYD4uL.jpg",
            ],
            "lowest_price": "35.52",
          },
          "weight": "0.16",
        },
        "B00I3MYCW4": {
          "image": "https://m.media-amazon.com/images/I/41zH77NdQ5L.jpg",
          "name": "Acorn Men's Moc Slippers, Charcoal, 10.5-11.5",
          "price": "42.0",
          "url": "https://www.amazon.com/dp/B00I3MYCW4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mSM9NpV8L.jpg",
              "https://m.media-amazon.com/images/I/5187UVDeZyL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31S-KFSEVvL.jpg",
              "https://m.media-amazon.com/images/I/414ayh3IOOL.jpg",
              "https://m.media-amazon.com/images/I/41ks4lBSouL.jpg",
              "https://m.media-amazon.com/images/I/41esjcmi7bL.jpg",
              "https://m.media-amazon.com/images/I/41D3VGALltL.jpg",
            ],
            "lowest_price": "42.0",
          },
          "weight": "0.16",
        },
        "B00I3MYIZU": {
          "image": "https://m.media-amazon.com/images/I/41zH77NdQ5L.jpg",
          "name": "Acorn Men's Moc Slippers, Charcoal, 9-10",
          "price": "42.0",
          "url": "https://www.amazon.com/dp/B00I3MYIZU?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mSM9NpV8L.jpg",
              "https://m.media-amazon.com/images/I/5187UVDeZyL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31S-KFSEVvL.jpg",
              "https://m.media-amazon.com/images/I/414ayh3IOOL.jpg",
              "https://m.media-amazon.com/images/I/41ks4lBSouL.jpg",
              "https://m.media-amazon.com/images/I/41esjcmi7bL.jpg",
              "https://m.media-amazon.com/images/I/41D3VGALltL.jpg",
            ],
            "lowest_price": "42.0",
          },
          "weight": "0.16",
        },
        "B00I3MYLIY": {
          "image": "https://m.media-amazon.com/images/I/41zH77NdQ5L.jpg",
          "name": "Acorn Men's Moc Slippers, Charcoal, 7.5-8.5",
          "price": "42.0",
          "url": "https://www.amazon.com/dp/B00I3MYLIY?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mSM9NpV8L.jpg",
              "https://m.media-amazon.com/images/I/5187UVDeZyL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31S-KFSEVvL.jpg",
              "https://m.media-amazon.com/images/I/414ayh3IOOL.jpg",
              "https://m.media-amazon.com/images/I/41ks4lBSouL.jpg",
              "https://m.media-amazon.com/images/I/41esjcmi7bL.jpg",
              "https://m.media-amazon.com/images/I/41D3VGALltL.jpg",
            ],
            "lowest_price": "42.0",
          },
          "weight": "0.16",
        },
        "B00I3MYOC2": {
          "image": "https://m.media-amazon.com/images/I/41zH77NdQ5L.jpg",
          "name": "Acorn Men's Moc Slippers, Charcoal, 12-13",
          "price": "32.74",
          "url": "https://www.amazon.com/dp/B00I3MYOC2?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "32.74",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mSM9NpV8L.jpg",
              "https://m.media-amazon.com/images/I/5187UVDeZyL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31S-KFSEVvL.jpg",
              "https://m.media-amazon.com/images/I/414ayh3IOOL.jpg",
              "https://m.media-amazon.com/images/I/41ks4lBSouL.jpg",
              "https://m.media-amazon.com/images/I/41esjcmi7bL.jpg",
              "https://m.media-amazon.com/images/I/41D3VGALltL.jpg",
            ],
            "lowest_price": "32.74",
          },
          "weight": "0.16",
        },
        "B00I3MYRWO": {
          "image": "https://m.media-amazon.com/images/I/41zH77NdQ5L.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Charcoal, 13.5-14.5",
          "price": "42.0",
          "url": "https://www.amazon.com/dp/B00I3MYRWO?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "42.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mSM9NpV8L.jpg",
              "https://m.media-amazon.com/images/I/5187UVDeZyL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31S-KFSEVvL.jpg",
              "https://m.media-amazon.com/images/I/414ayh3IOOL.jpg",
              "https://m.media-amazon.com/images/I/41ks4lBSouL.jpg",
              "https://m.media-amazon.com/images/I/41esjcmi7bL.jpg",
              "https://m.media-amazon.com/images/I/41D3VGALltL.jpg",
            ],
            "lowest_price": "42.0",
          },
          "weight": "0.16",
        },
        "B00I3MYXU0": {
          "image": "https://m.media-amazon.com/images/I/41z+H3nhgJL.jpg",
          "name": "Acorn Men's Moc Slippers, Chutney Plaid, 10.5-11.5",
          "price": "34.91",
          "url": "https://www.amazon.com/dp/B00I3MYXU0?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "34.92",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51MJ4J6JdsL.jpg",
              "https://m.media-amazon.com/images/I/51MhN3prVjL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41GtwoFX1RL.jpg",
              "https://m.media-amazon.com/images/I/41goLSX4fML.jpg",
              "https://m.media-amazon.com/images/I/41602GXrS1L.jpg",
              "https://m.media-amazon.com/images/I/41gwWtyVwRL.jpg",
              "https://m.media-amazon.com/images/I/41UmwS2BZsL.jpg",
            ],
            "lowest_price": "34.91",
          },
          "weight": "0.16",
        },
        "B00I3MZ0IE": {
          "image": "https://m.media-amazon.com/images/I/41z+H3nhgJL.jpg",
          "name": "Acorn Men's Moc Slippers, Chutney Plaid, 9-10",
          "price": "45.75",
          "url": "https://www.amazon.com/dp/B00I3MZ0IE?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.75",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51MJ4J6JdsL.jpg",
              "https://m.media-amazon.com/images/I/51MhN3prVjL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41GtwoFX1RL.jpg",
              "https://m.media-amazon.com/images/I/41goLSX4fML.jpg",
              "https://m.media-amazon.com/images/I/41602GXrS1L.jpg",
              "https://m.media-amazon.com/images/I/41gwWtyVwRL.jpg",
              "https://m.media-amazon.com/images/I/41UmwS2BZsL.jpg",
            ],
            "lowest_price": "45.75",
          },
          "weight": "0.16",
        },
        "B00I3MZ7L4": {
          "image": "https://m.media-amazon.com/images/I/41z+H3nhgJL.jpg",
          "name": "Acorn Men's Moc Slippers, Chutney Plaid, 12-13",
          "price": "39.96",
          "url": "https://www.amazon.com/dp/B00I3MZ7L4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter; while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis; Flatfoot; Talipes Valgus; and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable; rubber outsole provides weatherproof; skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor; perfect for checking the mails; walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5); Medium (9-10); Large (10.5-11.5); X-Large (12-13); XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "39.97",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51MJ4J6JdsL.jpg",
              "https://m.media-amazon.com/images/I/51MhN3prVjL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41GtwoFX1RL.jpg",
              "https://m.media-amazon.com/images/I/41goLSX4fML.jpg",
              "https://m.media-amazon.com/images/I/41602GXrS1L.jpg",
              "https://m.media-amazon.com/images/I/41gwWtyVwRL.jpg",
              "https://m.media-amazon.com/images/I/41UmwS2BZsL.jpg",
            ],
            "lowest_price": "39.96",
          },
          "weight": "0.16",
        },
        "B00L3ZRMF2": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Berber, 15-16",
          "price": "44.93",
          "url": "https://www.amazon.com/dp/B00L3ZRMF2?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": "35.0",
          },
          "weight": "0.16",
        },
        "B0134RC8RS": {
          "image": "https://m.media-amazon.com/images/I/41J5iIPQS1L.jpg",
          "name": "Acorn Men's Moc Summer Weight Slipper, Toast Canvas, Large/10.5-11.5 M US",
          "price": "39.77",
          "url": "https://www.amazon.com/dp/B0134RC8RS?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Classic style, lightweight comfort",
              "A summer update to our classic fall Acorn Moc",
              "Lighter-weight and breathable cotton blend uppers in summery colors and patterns",
              "Moisture-wicking, cotton blend terry linings and a durable suede sidewall",
              "Enjoy total cloud-like comfort with Acorn's proprietary Cloud Cushion footbed",
              "Non-slip outsole for indoor/outdoor wear - Care: Machine wash cold; air dry",
            ],
            "highest_price": "39.77",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51wT0MzstwL.jpg",
              "https://m.media-amazon.com/images/I/61wRrnEAOoL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/419bAtk5esL.jpg",
              "https://m.media-amazon.com/images/I/41HzW5fC8ZL.jpg",
              "https://m.media-amazon.com/images/I/51I4GPXKXNL.jpg",
              "https://m.media-amazon.com/images/I/41y55KVCZuL.jpg",
              "https://m.media-amazon.com/images/I/412P62zlW2L.jpg",
            ],
            "lowest_price": "39.77",
          },
          "weight": "0.17",
        },
        "B0134RCGO8": {
          "image": "https://m.media-amazon.com/images/I/41YxGjrjIIL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Stonewash Black Canvas, Small / 7.5-8.5 Regular US",
          "price": "34.35",
          "url": "https://www.amazon.com/dp/B0134RCGO8?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "34.35",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51U-ogbrxeL.jpg",
              "https://m.media-amazon.com/images/I/513GtZNGZEL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41iZ5RdHU1L.jpg",
              "https://m.media-amazon.com/images/I/415vlbvCOLL.jpg",
              "https://m.media-amazon.com/images/I/51HEbKzrd5L.jpg",
              "https://m.media-amazon.com/images/I/41OK6wrYVyL.jpg",
              "https://m.media-amazon.com/images/I/41CJb8wnTRL.jpg",
            ],
            "lowest_price": "34.35",
          },
          "weight": "0.17",
        },
        "B0134RCL52": {
          "image": "https://m.media-amazon.com/images/I/41YxGjrjIIL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Stonewash Black Canvas, Medium / 9-10 Regular US",
          "price": "30.53",
          "url": "https://www.amazon.com/dp/B0134RCL52?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "30.53",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51U-ogbrxeL.jpg",
              "https://m.media-amazon.com/images/I/513GtZNGZEL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41iZ5RdHU1L.jpg",
              "https://m.media-amazon.com/images/I/415vlbvCOLL.jpg",
              "https://m.media-amazon.com/images/I/51HEbKzrd5L.jpg",
              "https://m.media-amazon.com/images/I/41OK6wrYVyL.jpg",
              "https://m.media-amazon.com/images/I/41CJb8wnTRL.jpg",
            ],
            "lowest_price": "30.53",
          },
          "weight": "0.16",
        },
        "B0134RCQ2A": {
          "image": "https://m.media-amazon.com/images/I/41YxGjrjIIL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Stonewash Black Canvas, Large / 10.5-11.5 Regular US",
          "price": "29.33",
          "url": "https://www.amazon.com/dp/B0134RCQ2A?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "42.99",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51U-ogbrxeL.jpg",
              "https://m.media-amazon.com/images/I/513GtZNGZEL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41iZ5RdHU1L.jpg",
              "https://m.media-amazon.com/images/I/415vlbvCOLL.jpg",
              "https://m.media-amazon.com/images/I/51HEbKzrd5L.jpg",
              "https://m.media-amazon.com/images/I/41OK6wrYVyL.jpg",
              "https://m.media-amazon.com/images/I/41CJb8wnTRL.jpg",
            ],
            "lowest_price": "29.33",
          },
          "weight": "0.16",
        },
        "B0134RCU2G": {
          "image": "https://m.media-amazon.com/images/I/41YxGjrjIIL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam, Stonewash Black Canvas, X-Large / 12-13 Regular US",
          "price": "31.4",
          "url": "https://www.amazon.com/dp/B0134RCU2G?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "31.4",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51U-ogbrxeL.jpg",
              "https://m.media-amazon.com/images/I/513GtZNGZEL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41iZ5RdHU1L.jpg",
              "https://m.media-amazon.com/images/I/415vlbvCOLL.jpg",
              "https://m.media-amazon.com/images/I/51HEbKzrd5L.jpg",
              "https://m.media-amazon.com/images/I/41OK6wrYVyL.jpg",
              "https://m.media-amazon.com/images/I/41CJb8wnTRL.jpg",
            ],
            "lowest_price": "31.4",
          },
          "weight": "0.16",
        },
        "B01LWKGOF8": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Black Berber, 12-13 Wide",
          "price": null,
          "url": "https://www.amazon.com/dp/B01LWKGOF8?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B01LXVDUGG": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Black Berber, 10.5-11.5 Wide",
          "price": null,
          "url": "https://www.amazon.com/dp/B01LXVDUGG?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B01LY71Q09": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Black Berber, 9-10 Wide",
          "price": null,
          "url": "https://www.amazon.com/dp/B01LY71Q09?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam Comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and Durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B01M14I2VT": {
          "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Black Berber, 7.5-8.5 Wide",
          "price": null,
          "url": "https://www.amazon.com/dp/B01M14I2VT?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
              "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
              "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
              "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
              "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
              "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
              "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
              "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B01MT7TTA0": {
          "image": "https://m.media-amazon.com/images/I/414nruSfXiL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam Moccasin, Dark Charcoal, 13.5-14.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B01MT7TTA0?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51dBAlFo+bL.jpg",
              "https://m.media-amazon.com/images/I/511Ae7XjXhL.jpg",
              "https://m.media-amazon.com/images/I/41CzcIvvKGL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/31S1DOpqzrL.jpg",
              "https://m.media-amazon.com/images/I/316b3y8VLjL.jpg",
              "https://m.media-amazon.com/images/I/41i8cOpDHRL.jpg",
              "https://m.media-amazon.com/images/I/31bXqc1SxCL.jpg",
              "https://m.media-amazon.com/images/I/41n7GT-OquL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B01MY705B6": {
          "image": "https://m.media-amazon.com/images/I/414nruSfXiL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Dark Charcoal, 7.5-8.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B01MY705B6?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "39.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51dBAlFo+bL.jpg",
              "https://m.media-amazon.com/images/I/511Ae7XjXhL.jpg",
              "https://m.media-amazon.com/images/I/41CzcIvvKGL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31S1DOpqzrL.jpg",
              "https://m.media-amazon.com/images/I/316b3y8VLjL.jpg",
              "https://m.media-amazon.com/images/I/41i8cOpDHRL.jpg",
              "https://m.media-amazon.com/images/I/31bXqc1SxCL.jpg",
              "https://m.media-amazon.com/images/I/41n7GT-OquL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B01N4MSC51": {
          "image": "https://m.media-amazon.com/images/I/414nruSfXiL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Dark Charcoal, 10.5-11.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B01N4MSC51?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "33.75",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51dBAlFo+bL.jpg",
              "https://m.media-amazon.com/images/I/511Ae7XjXhL.jpg",
              "https://m.media-amazon.com/images/I/41CzcIvvKGL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31S1DOpqzrL.jpg",
              "https://m.media-amazon.com/images/I/316b3y8VLjL.jpg",
              "https://m.media-amazon.com/images/I/41i8cOpDHRL.jpg",
              "https://m.media-amazon.com/images/I/31bXqc1SxCL.jpg",
              "https://m.media-amazon.com/images/I/41n7GT-OquL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B01N4MSCFY": {
          "image": "https://m.media-amazon.com/images/I/414nruSfXiL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Dark Charcoal, 9-10",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B01N4MSCFY?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "33.75",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51dBAlFo+bL.jpg",
              "https://m.media-amazon.com/images/I/511Ae7XjXhL.jpg",
              "https://m.media-amazon.com/images/I/41CzcIvvKGL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31S1DOpqzrL.jpg",
              "https://m.media-amazon.com/images/I/316b3y8VLjL.jpg",
              "https://m.media-amazon.com/images/I/41i8cOpDHRL.jpg",
              "https://m.media-amazon.com/images/I/31bXqc1SxCL.jpg",
              "https://m.media-amazon.com/images/I/41n7GT-OquL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B01NBTG01V": {
          "image": "https://m.media-amazon.com/images/I/414nruSfXiL.jpg",
          "name": "Acorn Men's Moc Slippers Moccasin, Dark Charcoal, 12-13",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B01NBTG01V?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "33.75",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51dBAlFo+bL.jpg",
              "https://m.media-amazon.com/images/I/511Ae7XjXhL.jpg",
              "https://m.media-amazon.com/images/I/41CzcIvvKGL.jpg",
              "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
              "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
              "https://m.media-amazon.com/images/I/31S1DOpqzrL.jpg",
              "https://m.media-amazon.com/images/I/316b3y8VLjL.jpg",
              "https://m.media-amazon.com/images/I/41i8cOpDHRL.jpg",
              "https://m.media-amazon.com/images/I/31bXqc1SxCL.jpg",
              "https://m.media-amazon.com/images/I/41n7GT-OquL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B0742MTFJ6": {
          "image": "https://m.media-amazon.com/images/I/41GHNV7u6wL.jpg",
          "name": "Acorn Mens Moc Slipper, Adult, Earth Tex, XXL",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B0742MTFJ6?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Featuring a lofty Acorn memory-foam midsole over a comfort cushion layer of featherweight EVA",
              "In addition, the enhanced, raised heel and arch add extra stability and support",
              "Non-slip, weatherproof soles make them perfect for indoor/outdoor use",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51YSFQpfiqL.jpg",
              "https://m.media-amazon.com/images/I/51EYyXzQBrL.jpg",
              "https://m.media-amazon.com/images/I/31nPQSeumxL.jpg",
              "https://m.media-amazon.com/images/I/41ymHW1F8GL.jpg",
              "https://m.media-amazon.com/images/I/41M2zbGYvGL.jpg",
              "https://m.media-amazon.com/images/I/41+r0+pbcKL.jpg",
              "https://m.media-amazon.com/images/I/41SgLGYD4uL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": "0.85",
        },
        "B079941SL3": {
          "image": "https://m.media-amazon.com/images/I/41XabXV-zjL.jpg",
          "name": "Acorn Men's Moc Slippers, Navy Tweed, 9-10",
          "price": "32.11",
          "url": "https://www.amazon.com/dp/B079941SL3?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mpwmCLPjL.jpg",
              "https://m.media-amazon.com/images/I/51tUAgrHHsL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/310aEvYU6kL.jpg",
              "https://m.media-amazon.com/images/I/41RgAeQG32L.jpg",
              "https://m.media-amazon.com/images/I/41Q0aRwp8XL.jpg",
              "https://m.media-amazon.com/images/I/31eMg+sBEiL.jpg",
              "https://m.media-amazon.com/images/I/41QFBHJupxL.jpg",
            ],
            "lowest_price": "32.11",
          },
          "weight": "0.16",
        },
        "B079GBF4D9": {
          "image": "https://m.media-amazon.com/images/I/41XabXV-zjL.jpg",
          "name": "Acorn Men's Moc Slippers, Navy Tweed, 10.5-11.5",
          "price": "33.04",
          "url": "https://www.amazon.com/dp/B079GBF4D9?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mpwmCLPjL.jpg",
              "https://m.media-amazon.com/images/I/51tUAgrHHsL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/310aEvYU6kL.jpg",
              "https://m.media-amazon.com/images/I/41RgAeQG32L.jpg",
              "https://m.media-amazon.com/images/I/41Q0aRwp8XL.jpg",
              "https://m.media-amazon.com/images/I/31eMg+sBEiL.jpg",
              "https://m.media-amazon.com/images/I/41QFBHJupxL.jpg",
            ],
            "lowest_price": "33.04",
          },
          "weight": "0.16",
        },
        "B079K4MCG4": {
          "image": "https://m.media-amazon.com/images/I/41XabXV-zjL.jpg",
          "name": "Acorn Men's Moc Slippers, Navy Tweed, 12-13",
          "price": "35.15",
          "url": "https://www.amazon.com/dp/B079K4MCG4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mpwmCLPjL.jpg",
              "https://m.media-amazon.com/images/I/51tUAgrHHsL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/310aEvYU6kL.jpg",
              "https://m.media-amazon.com/images/I/41RgAeQG32L.jpg",
              "https://m.media-amazon.com/images/I/41Q0aRwp8XL.jpg",
              "https://m.media-amazon.com/images/I/31eMg+sBEiL.jpg",
              "https://m.media-amazon.com/images/I/41QFBHJupxL.jpg",
            ],
            "lowest_price": "35.15",
          },
          "weight": "0.16",
        },
        "B079NTV4ZC": {
          "image": "https://m.media-amazon.com/images/I/416Gqe0CXyL.jpg",
          "name": "Acorn Men's Moc Slippers, Urban Camo, 9-10",
          "price": "37.41",
          "url": "https://www.amazon.com/dp/B079NTV4ZC?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51z2eRKynhL.jpg",
              "https://m.media-amazon.com/images/I/516fkki24SL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/315d24wuCfL.jpg",
              "https://m.media-amazon.com/images/I/31rpL-fBDZL.jpg",
              "https://m.media-amazon.com/images/I/41vFOHmQo4L.jpg",
              "https://m.media-amazon.com/images/I/31ZdC16vGjL.jpg",
              "https://m.media-amazon.com/images/I/41S7rFFZTQL.jpg",
            ],
            "lowest_price": "37.41",
          },
          "weight": "0.16",
        },
        "B079RKLNJD": {
          "image": "https://m.media-amazon.com/images/I/41XabXV-zjL.jpg",
          "name": "Acorn Men's Moc Slippers, Navy Tweed, 7.5-8.5",
          "price": "43.46",
          "url": "https://www.amazon.com/dp/B079RKLNJD?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "43.46",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mpwmCLPjL.jpg",
              "https://m.media-amazon.com/images/I/51tUAgrHHsL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/310aEvYU6kL.jpg",
              "https://m.media-amazon.com/images/I/41RgAeQG32L.jpg",
              "https://m.media-amazon.com/images/I/41Q0aRwp8XL.jpg",
              "https://m.media-amazon.com/images/I/31eMg+sBEiL.jpg",
              "https://m.media-amazon.com/images/I/41QFBHJupxL.jpg",
            ],
            "lowest_price": "43.46",
          },
          "weight": "0.16",
        },
        "B079RL63HY": {
          "image": "https://m.media-amazon.com/images/I/416Gqe0CXyL.jpg",
          "name": "Acorn Men's Moc Slippers, Urban Camo, 10.5-11.5",
          "price": "45.0",
          "url": "https://www.amazon.com/dp/B079RL63HY?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51z2eRKynhL.jpg",
              "https://m.media-amazon.com/images/I/516fkki24SL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/315d24wuCfL.jpg",
              "https://m.media-amazon.com/images/I/31rpL-fBDZL.jpg",
              "https://m.media-amazon.com/images/I/41vFOHmQo4L.jpg",
              "https://m.media-amazon.com/images/I/31ZdC16vGjL.jpg",
              "https://m.media-amazon.com/images/I/41S7rFFZTQL.jpg",
            ],
            "lowest_price": "45.0",
          },
          "weight": "0.16",
        },
        "B079RL7HDT": {
          "image": "https://m.media-amazon.com/images/I/416Gqe0CXyL.jpg",
          "name": "Acorn Men's Moc Slippers, Urban Camo, 12-13",
          "price": "45.0",
          "url": "https://www.amazon.com/dp/B079RL7HDT?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51z2eRKynhL.jpg",
              "https://m.media-amazon.com/images/I/516fkki24SL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/315d24wuCfL.jpg",
              "https://m.media-amazon.com/images/I/31rpL-fBDZL.jpg",
              "https://m.media-amazon.com/images/I/41vFOHmQo4L.jpg",
              "https://m.media-amazon.com/images/I/31ZdC16vGjL.jpg",
              "https://m.media-amazon.com/images/I/41S7rFFZTQL.jpg",
            ],
            "lowest_price": "45.0",
          },
          "weight": "0.16",
        },
        "B079RM32S4": {
          "image": "https://m.media-amazon.com/images/I/41XabXV-zjL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam Slipper, Navy Tweed, 13.5-14.5",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B079RM32S4?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51mpwmCLPjL.jpg",
              "https://m.media-amazon.com/images/I/51tUAgrHHsL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/310aEvYU6kL.jpg",
              "https://m.media-amazon.com/images/I/41RgAeQG32L.jpg",
              "https://m.media-amazon.com/images/I/41Q0aRwp8XL.jpg",
              "https://m.media-amazon.com/images/I/31eMg+sBEiL.jpg",
              "https://m.media-amazon.com/images/I/41QFBHJupxL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": "0.16",
        },
        "B079RM3X1B": {
          "image": "https://m.media-amazon.com/images/I/416Gqe0CXyL.jpg",
          "name": "Acorn Men's Moc Slippers, Urban Camo, 7.5-8.5",
          "price": "41.08",
          "url": "https://www.amazon.com/dp/B079RM3X1B?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "41.08",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51z2eRKynhL.jpg",
              "https://m.media-amazon.com/images/I/315d24wuCfL.jpg",
              "https://m.media-amazon.com/images/I/516fkki24SL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31rpL-fBDZL.jpg",
              "https://m.media-amazon.com/images/I/41vFOHmQo4L.jpg",
              "https://m.media-amazon.com/images/I/31ZdC16vGjL.jpg",
              "https://m.media-amazon.com/images/I/41S7rFFZTQL.jpg",
            ],
            "lowest_price": "41.08",
          },
          "weight": "0.16",
        },
        "B07DFV3SCM": {
          "image": "https://m.media-amazon.com/images/I/41nSBKKYkBL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Tweed, 12-13",
          "price": "31.93",
          "url": "https://www.amazon.com/dp/B07DFV3SCM?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "50.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51lzHIzrWsL.jpg",
              "https://m.media-amazon.com/images/I/518P1bhz1cL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31ffOnBwFHL.jpg",
              "https://m.media-amazon.com/images/I/31SApuYWY7L.jpg",
              "https://m.media-amazon.com/images/I/41Pv9DGEguL.jpg",
              "https://m.media-amazon.com/images/I/41FhZ5YSdQL.jpg",
              "https://m.media-amazon.com/images/I/41ptjKx95OL.jpg",
            ],
            "lowest_price": "31.93",
          },
          "weight": "0.16",
        },
        "B07DFV8MCJ": {
          "image": "https://m.media-amazon.com/images/I/415WW+q3CtL.jpg",
          "name": "Acorn Men's Moc Slippers, Brown Tweed, 12-13",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B07DFV8MCJ?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "50.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51EsBV7meGL.jpg",
              "https://m.media-amazon.com/images/I/51whSwhmWNL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31JPsm3gS9L.jpg",
              "https://m.media-amazon.com/images/I/41uZ-cGRlpL.jpg",
              "https://m.media-amazon.com/images/I/41MiuadAYjL.jpg",
              "https://m.media-amazon.com/images/I/41N68yPt2xL.jpg",
              "https://m.media-amazon.com/images/I/41o9hERInzL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B07DFX4Q2T": {
          "image": "https://m.media-amazon.com/images/I/416Gqe0CXyL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam Slipper, Urban Camo, 13.5-14.5",
          "price": "43.83",
          "url": "https://www.amazon.com/dp/B07DFX4Q2T?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51z2eRKynhL.jpg",
              "https://m.media-amazon.com/images/I/31rpL-fBDZL.jpg",
              "https://m.media-amazon.com/images/I/41vFOHmQo4L.jpg",
              "https://m.media-amazon.com/images/I/516fkki24SL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/315d24wuCfL.jpg",
              "https://m.media-amazon.com/images/I/31ZdC16vGjL.jpg",
              "https://m.media-amazon.com/images/I/41S7rFFZTQL.jpg",
            ],
            "lowest_price": "43.83",
          },
          "weight": "0.16",
        },
        "B07DFXT1B9": {
          "image": "https://m.media-amazon.com/images/I/41nSBKKYkBL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Tweed, 9-10",
          "price": null,
          "url": "https://www.amazon.com/dp/B07DFXT1B9?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51lzHIzrWsL.jpg",
              "https://m.media-amazon.com/images/I/518P1bhz1cL.jpg",
              "https://m.media-amazon.com/images/I/31ffOnBwFHL.jpg",
              "https://m.media-amazon.com/images/I/31SApuYWY7L.jpg",
              "https://m.media-amazon.com/images/I/41Pv9DGEguL.jpg",
              "https://m.media-amazon.com/images/I/41FhZ5YSdQL.jpg",
              "https://m.media-amazon.com/images/I/41ptjKx95OL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B07DFYCHDR": {
          "image": "https://m.media-amazon.com/images/I/41nSBKKYkBL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Tweed, 7.5-8.5",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B07DFYCHDR?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51lzHIzrWsL.jpg",
              "https://m.media-amazon.com/images/I/518P1bhz1cL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31ffOnBwFHL.jpg",
              "https://m.media-amazon.com/images/I/31SApuYWY7L.jpg",
              "https://m.media-amazon.com/images/I/41Pv9DGEguL.jpg",
              "https://m.media-amazon.com/images/I/41FhZ5YSdQL.jpg",
              "https://m.media-amazon.com/images/I/41ptjKx95OL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": "0.16",
        },
        "B07DFZB9YW": {
          "image": "https://m.media-amazon.com/images/I/41nSBKKYkBL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam Slipper, Black Tweed, 13.5-14.5",
          "price": "38.27",
          "url": "https://www.amazon.com/dp/B07DFZB9YW?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51lzHIzrWsL.jpg",
              "https://m.media-amazon.com/images/I/518P1bhz1cL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31ffOnBwFHL.jpg",
              "https://m.media-amazon.com/images/I/31SApuYWY7L.jpg",
              "https://m.media-amazon.com/images/I/41Pv9DGEguL.jpg",
              "https://m.media-amazon.com/images/I/41FhZ5YSdQL.jpg",
              "https://m.media-amazon.com/images/I/41ptjKx95OL.jpg",
            ],
            "lowest_price": "38.27",
          },
          "weight": "0.16",
        },
        "B07DFZGF3D": {
          "image": "https://m.media-amazon.com/images/I/41nSBKKYkBL.jpg",
          "name": "Acorn Men's Moc Slippers, Black Tweed, 10.5-11.5",
          "price": null,
          "url": "https://www.amazon.com/dp/B07DFZGF3D?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": null,
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": null,
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51lzHIzrWsL.jpg",
              "https://m.media-amazon.com/images/I/518P1bhz1cL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31ffOnBwFHL.jpg",
              "https://m.media-amazon.com/images/I/31SApuYWY7L.jpg",
              "https://m.media-amazon.com/images/I/41Pv9DGEguL.jpg",
              "https://m.media-amazon.com/images/I/41FhZ5YSdQL.jpg",
              "https://m.media-amazon.com/images/I/41ptjKx95OL.jpg",
            ],
            "lowest_price": null,
          },
          "weight": "0.16",
        },
        "B07DFZR5C6": {
          "image": "https://m.media-amazon.com/images/I/415WW+q3CtL.jpg",
          "name": "Acorn Men's Moc with Premium Memory Foam Slipper, Brown Tweed, 13.5-14.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B07DFZR5C6?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51EsBV7meGL.jpg",
              "https://m.media-amazon.com/images/I/51whSwhmWNL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31JPsm3gS9L.jpg",
              "https://m.media-amazon.com/images/I/41uZ-cGRlpL.jpg",
              "https://m.media-amazon.com/images/I/41MiuadAYjL.jpg",
              "https://m.media-amazon.com/images/I/41N68yPt2xL.jpg",
              "https://m.media-amazon.com/images/I/41o9hERInzL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B07DFZRG3Z": {
          "image": "https://m.media-amazon.com/images/I/415WW+q3CtL.jpg",
          "name": "Acorn Men's Moc Slippers, Brown Tweed, 9-10",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B07DFZRG3Z?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51EsBV7meGL.jpg",
              "https://m.media-amazon.com/images/I/51whSwhmWNL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31JPsm3gS9L.jpg",
              "https://m.media-amazon.com/images/I/41uZ-cGRlpL.jpg",
              "https://m.media-amazon.com/images/I/41MiuadAYjL.jpg",
              "https://m.media-amazon.com/images/I/41N68yPt2xL.jpg",
              "https://m.media-amazon.com/images/I/41o9hERInzL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B07DG327YH": {
          "image": "https://m.media-amazon.com/images/I/415WW+q3CtL.jpg",
          "name": "Acorn Men's Moc Slippers, Brown Tweed, 7.5-8.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B07DG327YH?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "PREMIUM DESIGN: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "STYLISH AND BREATHABLE: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "MEMORY FOAM COMFORT: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "VERSATILE AND DURABLE: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "SIZE AND EASY CARE: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51EsBV7meGL.jpg",
              "https://m.media-amazon.com/images/I/51whSwhmWNL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31JPsm3gS9L.jpg",
              "https://m.media-amazon.com/images/I/41uZ-cGRlpL.jpg",
              "https://m.media-amazon.com/images/I/41MiuadAYjL.jpg",
              "https://m.media-amazon.com/images/I/41N68yPt2xL.jpg",
              "https://m.media-amazon.com/images/I/41o9hERInzL.jpg",
            ],
            "lowest_price": "33.7",
          },
          "weight": "0.16",
        },
        "B07DG3HJLW": {
          "image": "https://m.media-amazon.com/images/I/415WW+q3CtL.jpg",
          "name": "Acorn Men's Moc Slippers, Brown Tweed, 10.5-11.5",
          "price": "33.75",
          "url": "https://www.amazon.com/dp/B07DG3HJLW?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men\u2019s signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter, while moisture-wicking lining keeps feet dry.",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit. Helps alleviate sore and tired feet and foot pain associated with Plantar Fasciitis, Flatfoot, Talipes Valgus, and Splayfoot.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing. Slippers transition you effortlessly from indoor to outdoor, perfect for checking the mails, walking the dog or a quick errand.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit. Available sizes Small (7.5-8.5), Medium (9-10), Large (10.5-11.5), X-Large (12-13), XX-Large (14-15). Available in wide sizes in Black Berber only. Care: Machine wash cool water; dry flat away from heat Care: Machine wash cold; air dry.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51EsBV7meGL.jpg",
              "https://m.media-amazon.com/images/I/51whSwhmWNL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31JPsm3gS9L.jpg",
              "https://m.media-amazon.com/images/I/41uZ-cGRlpL.jpg",
              "https://m.media-amazon.com/images/I/41MiuadAYjL.jpg",
              "https://m.media-amazon.com/images/I/41N68yPt2xL.jpg",
              "https://m.media-amazon.com/images/I/41o9hERInzL.jpg",
            ],
            "lowest_price": "33.75",
          },
          "weight": "0.16",
        },
        "B07NNMYM98": {
          "image": "https://m.media-amazon.com/images/I/41Uvop+gpLL.jpg",
          "name": "ACORN Acorn Moc Men, Color: Brown Berber, Size: M (A10086BOBMM)",
          "price": "34.95",
          "url": "https://www.amazon.com/dp/B07NNMYM98?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit.",
            ],
            "highest_price": "34.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51WfDnXofWL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/41Sqg4ss2kL.jpg",
              "https://m.media-amazon.com/images/I/41bxEPqchjL.jpg",
              "https://m.media-amazon.com/images/I/516EFVbkIDL.jpg",
              "https://m.media-amazon.com/images/I/31Fg6BbE9+L.jpg",
              "https://m.media-amazon.com/images/I/41zX68stoeL.jpg",
              "https://m.media-amazon.com/images/I/417y3PF-RyL.jpg",
            ],
            "lowest_price": "34.95",
          },
          "weight": null,
        },
        "B07NNPBH65": {
          "image": "https://m.media-amazon.com/images/I/41Uvop+gpLL.jpg",
          "name": "ACORN Acorn Moc Men, Color: Brown Berber, Size: S (A10086BOBMS)",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B07NNPBH65?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/516EFVbkIDL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31Fg6BbE9+L.jpg",
              "https://m.media-amazon.com/images/I/41zX68stoeL.jpg",
              "https://m.media-amazon.com/images/I/417y3PF-RyL.jpg",
              "https://m.media-amazon.com/images/I/51WfDnXofWL.jpg",
              "https://m.media-amazon.com/images/I/41Sqg4ss2kL.jpg",
              "https://m.media-amazon.com/images/I/41bxEPqchjL.jpg",
            ],
            "lowest_price": "37.11",
          },
          "weight": null,
        },
        "B07NNVGMVY": {
          "image": "https://m.media-amazon.com/images/I/41Uvop+gpLL.jpg",
          "name": "ACORN Acorn Moc Men, Color: Brown Berber, Size: XXL (A10086BOBMXXL)",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B07NNVGMVY?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51WfDnXofWL.jpg",
              "https://m.media-amazon.com/images/I/516EFVbkIDL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31Fg6BbE9+L.jpg",
              "https://m.media-amazon.com/images/I/41Sqg4ss2kL.jpg",
              "https://m.media-amazon.com/images/I/41zX68stoeL.jpg",
              "https://m.media-amazon.com/images/I/417y3PF-RyL.jpg",
              "https://m.media-amazon.com/images/I/41bxEPqchjL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": null,
        },
        "B07NNY8FTG": {
          "image": "https://m.media-amazon.com/images/I/41Uvop+gpLL.jpg",
          "name": "ACORN Acorn Moc Men, Color: Brown Berber, Size: XL (A10086BOBMXL)",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B07NNY8FTG?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit.",
            ],
            "highest_price": "44.95",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51WfDnXofWL.jpg",
              "https://m.media-amazon.com/images/I/516EFVbkIDL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31Fg6BbE9+L.jpg",
              "https://m.media-amazon.com/images/I/41Sqg4ss2kL.jpg",
              "https://m.media-amazon.com/images/I/41zX68stoeL.jpg",
              "https://m.media-amazon.com/images/I/417y3PF-RyL.jpg",
              "https://m.media-amazon.com/images/I/41bxEPqchjL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": "0.50",
        },
        "B07NP33YMB": {
          "image": "https://m.media-amazon.com/images/I/41Uvop+gpLL.jpg",
          "name": "ACORN Acorn Moc Men, Color: Brown Berber, Size: L (A10086BOBML)",
          "price": "44.95",
          "url": "https://www.amazon.com/dp/B07NP33YMB?tag=perusmart0a-20&linkCode=ogv&th=1&psc=1",
          "vendorData": {
            "condition": "New",
            "features_description": [
              "Premium design: Men's signature moccasin House shoe in slip-on closed back design with indoor and outdoor support. Perfect for men of all ages and lifestyles.",
              "Stylish and breathable: Available in a variety of cozy and breathable fabrics for all-year comfort that keep your feet cool in the summer and warm during the winter",
              "Memory foam comfort: Flexible multilayer Cloud Cushion insole memory foam foot bed for support that cradles the contour of your foot for a therapeutic fit.",
              "Versatile and durable: Genuine suede sidewall with durable, rubber outsole provides weatherproof, skid-resistant traction for safe and secure footing.",
              "Size and easy care: This slipper runs small; we recommend ordering the next size up for the most comfortable and flexible fit.",
            ],
            "highest_price": "45.0",
            "image_url_set": [
              "https://m.media-amazon.com/images/I/51WfDnXofWL.jpg",
              "https://m.media-amazon.com/images/I/516EFVbkIDL.jpg",
              "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
              "https://m.media-amazon.com/images/I/31Fg6BbE9+L.jpg",
              "https://m.media-amazon.com/images/I/41Sqg4ss2kL.jpg",
              "https://m.media-amazon.com/images/I/41zX68stoeL.jpg",
              "https://m.media-amazon.com/images/I/417y3PF-RyL.jpg",
              "https://m.media-amazon.com/images/I/41bxEPqchjL.jpg",
            ],
            "lowest_price": "44.95",
          },
          "weight": null,
        },
      },
    },
    "image": "https://m.media-amazon.com/images/I/31W9ZuQcoQL.jpg",
    "name": "Acorn Men's Moc Slippers",
    "onlineStore": {
      "id": "ST04287850",
      "logo": "https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png",
      "name": "Amazon",
      "slug": "amazon",
      "type": "online-store",
      "url": "https://www.amazon.com/",
    },
    "price": null,
    "shipping": null,
    "url": "https://www.amazon.com/dp/B07QPY5X1L?tag=perusmart0a-20&linkCode=ogi&th=1&psc=1",
    "vendorData": {
      "best_seller": false,
      "condition": null,
      "features_description": null,
      "highest_price": null,
      "image_url_set": [
        "https://m.media-amazon.com/images/I/41oXEWlGRnL.jpg",
        "https://m.media-amazon.com/images/I/41vgS7ERbVL.jpg",
        "https://m.media-amazon.com/images/I/317YOBRGeRL.jpg",
        "https://m.media-amazon.com/images/I/4151kQy-HzL.jpg",
        "https://m.media-amazon.com/images/I/51ygn9Ob+1L.jpg",
        "https://m.media-amazon.com/images/I/51T5HTeuLwL.jpg",
        "https://m.media-amazon.com/images/I/51CfyyNJTiL.jpg",
        "https://m.media-amazon.com/images/I/51x1EhrWCDL.jpg",
        "https://m.media-amazon.com/images/I/3111MdOaFiL.jpg",
        "https://m.media-amazon.com/images/I/31iy65wVf-L.jpg",
        "https://m.media-amazon.com/images/I/31n6k5U7xuL.jpg",
        "https://m.media-amazon.com/images/I/31+5oZS-sKL.jpg",
        "https://m.media-amazon.com/images/I/315EP4kmfrL.jpg",
      ],
      "lowest_price": null,
    },
    "weight": "0.16",
  },
).pipe(delay(800));*/



// WEBPACK FOOTER //
// ./src/modules/scrap/api.js